import $ from 'jquery';

export default class AnchorLinks {
  init(parentSelector, callback) {
    let currentlyAnimating = false;
    // Select all links with hashes
    $(`${parentSelector} a[href*="#"]`)
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .on('touch click', (event) => {
        if (event.type == 'touch'){
          $(this).off('click');
        }
        // On-page links
        let self = event.target;

        // If click is on child element of anchor we need
        // to propegate up to the anchor element to get hash
        while (self) {
          if (self instanceof HTMLAnchorElement) {
            break;
          }
          self = self.parentNode;
        }

        if (
          location.pathname.replace(/^\//, '') == self.pathname.replace(/^\//, '')
          &&
          location.hostname == self.hostname
        ) {
          event.preventDefault();

          // Figure out element to scroll to
          let target = $(self.hash);
          target = target.length ? target : $('[name=' + self.hash.slice(1) + ']');

          // Does a scroll target exist?
          if (target.length) {
            const scrollTop = target.offset().top - 150;

            if (currentlyAnimating) {
              return;
            }

            currentlyAnimating = true;

            // Scroll to target
            $('html, body').animate({
              scrollTop,
            }, 500, () => {
              /*
              // Callback after animation
              // Must change focus!
              const $target = $(target);
              $target.focus();

              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
              */

              if (callback) {
                callback(parentSelector);
              }

              currentlyAnimating = false;
            });
          } else {
            currentlyAnimating = false;
          }
        } else {
          currentlyAnimating = false;
        }
      });
  }
}
